import { Component, inject } from '@angular/core';
import {
  Toast,
  ToastService,
  ToastType,
} from '../../services/toast/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  readonly toastService = inject(ToastService);

  readonly iconMap: Record<ToastType, string> = {
    success: 'check_circle',
    error: 'error',
    warn: 'warning_amber',
    info: 'info',
  };

  trackById(_: number, toast: Toast): string {
    return toast.id;
  }
}
